import { createEmitter } from "ts_utils";
import { ValidationUtils } from "ts_utils";
import { FbAuth } from "../../services/firebase/FbAuth";
import { UserManager } from "../UserManager";
import * as uih from "./UiHelper";

export class CreateAccountView {
	
	private _ui:HTMLDivElement;
	
	private _emailInput:HTMLInputElement;
	private _passwordInput:HTMLInputElement;
	private _confirmPasswordInput:HTMLInputElement;
	
	private _messageDiv:HTMLDivElement;
	
	private _createAccountBtn:HTMLButtonElement;
	private _cancelBtn:HTMLButtonElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<CreateAccountViewEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		this._init();
	}
	
	private _init():void {
		uih.hide(this._ui);
		
		this._emailInput = this._ui.querySelector("#cav-emailInput");
		this._passwordInput = this._ui.querySelector("#cav-passwordInput");
		this._confirmPasswordInput = this._ui.querySelector(
			"#cav-confirmPasswordInput");
		
		this._messageDiv = this._ui.querySelector(".shacc-message");
		uih.hide(this._messageDiv);
		
		this._createAccountBtn = this._ui.querySelector("#cav-createBtn");
		this._cancelBtn = this._ui.querySelector("#cav-cancelBtn");
	}
	
	public activate():void {
		this._emailInput.value = "";
		this._passwordInput.value = "";
		this._confirmPasswordInput.value = "";
		
		UserManager.get().hideLoadingOverlay();
		uih.hide(this._messageDiv);
		uih.show(this._ui);
		this._addListeners();
	}
	
	public deactivate():void {
		uih.hide(this._ui);
		this._removeListeners();
	}
	
	private _onCreateAccountBtnClick = async (e:MouseEvent):Promise<void> => {
		let email:string = this._emailInput.value;
		let password:string = this._passwordInput.value;
		
		
		if (password !== this._confirmPasswordInput.value){
			this._messageDiv.innerHTML = "Passwords don't match.";
			uih.show(this._messageDiv);
			return;
		}
		if (!ValidationUtils.isValidEmail(email)){
			this._messageDiv.innerHTML = "Please enter a valid email address.";
			uih.show(this._messageDiv);
			return;
		}
		if (!ValidationUtils.validatePassword(password).pass){
			this._messageDiv.innerHTML = "Password must contain upper and " +
				"lower case letters and at least one number";
			uih.show(this._messageDiv);
			return;
		}
		
		this._removeListeners();
		UserManager.get().showLoadingOverlay();
		await this._createUserViaService(email, password);	
	}
	
	private _onCancelBtnClick = (e:MouseEvent):void => {
		let event = new CreateAccountViewEvent();
		event.type = CreateAccountViewEventType.canceled;
		this._emitter.emit(event);
	}
	
	private async _createUserViaService(email:string, password:string)
			:Promise<void> {
		try {
			await FbAuth.createUserWithEmailAndPassword(email, password);
			let event = new CreateAccountViewEvent()
			event.type = CreateAccountViewEventType.accountCreated;
			this._emitter.emit(event);
		}
		catch (err) {
			console.log(err);
			UserManager.get().hideLoadingOverlay();
			this._addListeners();
			return null;
		}
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._createAccountBtn.addEventListener("click",
			this._onCreateAccountBtnClick);
		this._cancelBtn.addEventListener("click", this._onCancelBtnClick);
	}
	
	private _removeListeners():void {
		this._createAccountBtn.removeEventListener("click",
			this._onCreateAccountBtnClick);
		this._cancelBtn.removeEventListener("click", this._onCancelBtnClick);
	}
}

export class CreateAccountViewEvent {
	public type:CreateAccountViewEventType;
}

export enum CreateAccountViewEventType {
	accountCreated,
	canceled
}